import { FC } from "react"
import { Checkbox } from "@radix-ui/themes"

export const StripMagCustomArgs: FC<{
  values: { [key: string]: boolean }
  setValue: (values: { [key: string]: boolean }) => void
}> = ({ values, setValue }) => {
  return (
    <label>
      <Checkbox
        checked={values.isFastStock}
        onCheckedChange={(value) =>
          setValue({ ...values, isFastStock: value === true })
        }
      />
      Только с быстрой отгрузкой
    </label>
  )
}
